import { lsGet, safeAwait } from 'utils/request'

export const getClassification = (classificationId) => {
  return safeAwait(lsGet(`/serviceClassifications/${classificationId}`))
}
